import { jsx } from 'react/jsx-runtime';
import 'react';
import styled from '@emotion/styled';

const headingConfigs = {
    default: {
        "font-style": "normal",
        "font-weight": "700",
        "line-height": "125%",
        margin: "0",
        padding: "0",
    },
    huge: {
        tag: "h1",
        desktop: {
            "font-size": "60px",
        },
        laptop: {
            "font-size": "48px",
        },
        tablet: {
            "font-size": "36px",
        },
        phone: {
            "font-size": "36px",
        },
    },
    large: {
        tag: "h2",
        desktop: {
            "font-size": "48px",
        },
        laptop: {
            "font-size": "36px",
        },
        tablet: {
            "font-size": "28px",
        },
        phone: {
            "font-size": "28px",
        },
    },
    medium: {
        tag: "h3",
        desktop: {
            "font-size": "36px",
        },
        laptop: {
            "font-size": "28px",
        },
        tablet: {
            "font-size": "24px",
        },
        phone: {
            "font-size": "24px",
        },
    },
    small: {
        tag: "h4",
        desktop: {
            "font-size": "28px",
        },
        laptop: {
            "font-size": "24px",
        },
        tablet: {
            "font-size": "20px",
        },
        phone: {
            "font-size": "20px",
        },
    },
    smaller: {
        tag: "h5",
        desktop: {
            "font-size": "24px",
        },
        laptop: {
            "font-size": "20px",
        },
        tablet: {
            "font-size": "18px",
        },
        phone: {
            "font-size": "18px",
        },
    },
    smallest: {
        tag: "h6",
        desktop: {
            "font-size": "20px",
        },
        laptop: {
            "font-size": "18px",
        },
        tablet: {
            "font-size": "16px",
        },
        phone: {
            "font-size": "16px",
        },
    },
};

const textConfigs = {
    large: {
        "font-size": "22px",
        "line-height": "175%",
    },
    medium: {
        "font-size": "15px",
        "line-height": "167%",
    },
    small: {
        "font-size": "12px",
        "line-height": "140%",
    },
};

const StyledHeader = styled.div `
    color: ${({ theme }) => theme.colors.heading};
    font-style: ${headingConfigs.default["font-style"]};
    font-weight: ${headingConfigs.default["font-weight"]};
    line-height: ${headingConfigs.default["line-height"]};
    margin: ${headingConfigs.default["margin"]};
    padding: ${headingConfigs.default["padding"]};
    font-size: ${({ variant }) => headingConfigs[variant].phone["font-size"]};
    ${(props) => props.theme.mediaQueries.sm} {
        font-size: ${({ variant }) => headingConfigs[variant].tablet["font-size"]};
    }
    ${(props) => props.theme.mediaQueries.lg} {
        font-size: ${({ variant }) => headingConfigs[variant].laptop["font-size"]};
    }
    ${(props) => props.theme.mediaQueries["2xl"]} {
        font-size: ${({ variant }) => headingConfigs[variant].desktop["font-size"]};
    }
`;
const HugeHeading = ({ children, ...props }) => {
    const tag = headingConfigs["huge"].tag;
    return (jsx(StyledHeader, { as: tag, variant: "huge", ...props, children: children }));
};
const LargeHeading = ({ children, ...props }) => {
    const tag = headingConfigs["large"].tag;
    return (jsx(StyledHeader, { as: tag, variant: "large", ...props, children: children }));
};
const MediumHeading = ({ children, ...props }) => {
    const tag = headingConfigs["medium"].tag;
    return (jsx(StyledHeader, { as: tag, variant: "medium", ...props, children: children }));
};
const SmallHeading = ({ children, ...props }) => {
    const tag = headingConfigs["small"].tag;
    return (jsx(StyledHeader, { as: tag, variant: "small", ...props, children: children }));
};
const SmallerHeading = ({ children, ...props }) => {
    const tag = headingConfigs["smaller"].tag;
    return (jsx(StyledHeader, { as: tag, variant: "smaller", ...props, children: children }));
};
const SmallestHeading = ({ children, ...props }) => {
    const tag = headingConfigs["smallest"].tag;
    return (jsx(StyledHeader, { as: tag, variant: "smallest", ...props, children: children }));
};

const StyledText = styled.div `
    color: ${({ theme }) => theme.colors.textDefault};
    font-size: ${({ variant }) => textConfigs[variant]["font-size"]};
    line-height: ${({ variant }) => textConfigs[variant]["line-height"]};
    font-weight: ${({ bold }) => (bold ? "700" : "400")};
`;
const LargeText = ({ bold, children, ...props }) => {
    return (jsx(StyledText, { variant: "large", bold: bold, ...props, children: children }));
};
const MediumText = ({ bold, children, ...props }) => {
    return (jsx(StyledText, { variant: "medium", bold: bold, ...props, children: children }));
};
const SmallText = ({ bold, children, ...props }) => {
    return (jsx(StyledText, { variant: "small", bold: bold, ...props, children: children }));
};

const Heading = {
    Huge: HugeHeading,
    Large: LargeHeading,
    Medium: MediumHeading,
    Small: SmallHeading,
    Smaller: SmallerHeading,
    Smallest: SmallestHeading,
};
const Text = {
    Large: LargeText,
    Medium: MediumText,
    Small: SmallText,
};

export { Heading, Text };
